if (!customElements.get('fixed-bottom-bar')) {
  customElements.define(
    'fixed-bottom-bar',
    class FixedBottomBar extends HTMLElement {
      constructor() {
        super();

        this.bar = this.querySelector('.fixed-bottom-bar');
        this.productForm = null;
        this.productInfo = null;
        this.featuresAccordion = null;
        this.observer = null;
        this.isVisible = false;
        this.isProductFormOutOfView = false;
        this.isProductInfoInView = false;
        this.isFeaturesAccordionInView = false;
        this.VISIBILITY_MARGIN = 100; // 要素の下端が画面下端から何px以内で非表示にするか

        this.init();
      }

      init() {
        const productFormId = this.dataset.productFormId;

        this.productForm = this.findProductForm(productFormId);
        if (!this.productForm) {
          console.warn('Product form not found for fixed bottom bar. Expected form ID:', productFormId);
          return;
        }

        this.productInfo = document.querySelector('fac-product-info');
        this.featuresAccordion = document.querySelector('.fac-features-accordion');

        this.setupProductFormObserver();
        this.setupScrollHandler();
        this.setupClickHandlers();
      }

      findProductForm(productFormId) {
        if (!productFormId) return null;

        // Try to find by form ID
        const formElement = document.querySelector(`#${productFormId}`);
        if (formElement) {
          const productForm = formElement.closest('product-form');
          if (productForm) return productForm;
        }

        // Try to find product-form within the section
        const sectionElement = document.querySelector(`[id*="${productFormId}"]`);
        if (sectionElement) {
          const productForm = sectionElement.querySelector('product-form');
          if (productForm) return productForm;
        }

        // Last resort: find any product-form on the page
        return document.querySelector('product-form');
      }

      setupProductFormObserver() {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // 画面内にある場合はfalse
              this.isProductFormOutOfView = false;
            } else {
              // 画面外の場合、上側に出ているかチェック
              const rect = this.productForm.getBoundingClientRect();
              this.isProductFormOutOfView = rect.bottom < 0;
            }
            this.updateBarVisibility();
          });
        });

        this.observer.observe(this.productForm);
      }

      setupScrollHandler() {
        let ticking = false;
        const throttledHandler = () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              this.checkVisibility();
              ticking = false;
            });
            ticking = true;
          }
        };

        window.addEventListener('scroll', throttledHandler, { passive: true });
        this.throttledScrollHandler = throttledHandler;
      }

      checkVisibility() {
        this.checkElementVisibility(this.productInfo, 'isProductInfoInView');
        this.checkElementVisibility(this.featuresAccordion, 'isFeaturesAccordionInView');
        this.updateBarVisibility();
      }

      checkElementVisibility(element, propertyName) {
        if (!element) {
          this[propertyName] = false;
          return;
        }

        const rect = element.getBoundingClientRect();
        // 要素の上端が画面下端より上 AND 下端が画面下端+マージンより下
        this[propertyName] = rect.top < window.innerHeight && rect.bottom > window.innerHeight + this.VISIBILITY_MARGIN;
      }

      updateBarVisibility() {
        // 表示条件: 商品フォームが画面外 AND (product-infoまたはfeatures-accordionが画面内)
        const shouldShow =
          this.isProductFormOutOfView &&
          (this.isProductInfoInView || this.isFeaturesAccordionInView);

        if (shouldShow) {
          this.showBar();
        } else {
          this.hideBar();
        }
      }

      setupClickHandlers() {
        const ctaButton = this.querySelector('.fixed-bottom-bar__cta');
        if (ctaButton) {
          ctaButton.addEventListener('click', () => {
            this.scrollToProductForm();
          });
        }
      }

      scrollToProductForm() {
        if (!this.productForm) return;

        const offset = 600;
        const top = this.productForm.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: top,
          behavior: 'smooth',
        });
      }

      showBar() {
        if (!this.isVisible) {
          this.bar.classList.add('is-visible');
          this.isVisible = true;
        }
      }

      hideBar() {
        if (this.isVisible) {
          this.bar.classList.remove('is-visible');
          this.isVisible = false;
        }
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
        if (this.throttledScrollHandler) {
          window.removeEventListener('scroll', this.throttledScrollHandler);
        }
      }
    }
  );
}
